import { IncentiveOfferType } from 'modules/incentivesMarket/types';

type ResolveIncentiveOfferOperationPartiesArgs = {
  offerType: IncentiveOfferType;
  publisherBeneficiaryId: string;
  participantBeneficiaryId: string;
};

export const resolveIncentiveOfferOperationParties = ({
  offerType,
  publisherBeneficiaryId,
  participantBeneficiaryId,
}: ResolveIncentiveOfferOperationPartiesArgs): {
  buyer: string;
  seller: string;
} => {
  const isSell = offerType === IncentiveOfferType.SELL;
  return {
    buyer: isSell ? participantBeneficiaryId : publisherBeneficiaryId,
    seller: isSell ? publisherBeneficiaryId : participantBeneficiaryId,
  };
};
